import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'primeng/chart';
import type { DashboardData } from '../../../services/dashboard.service';
import { formatDashboardCurrency, heatMapCells } from '../dashboard-utils';

@Component({
  selector: 'app-dash-collection-timeline',
  templateUrl: './dash-collection-timeline.widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ChartModule],
  styles: [':host { display: block; height: 100%; }']
})
export class DashCollectionTimelineWidgetComponent {
  data = input<DashboardData | null>(null);

  readonly formatCurrency = formatDashboardCurrency;

  readonly chartData = computed(() => {
    const cells = heatMapCells(this.data());
    return {
      labels: cells.map((c) => c.date.slice(5)),
      datasets: [
        {
          label: 'Cobranza',
          data: cells.map((c) => c.amount),
          backgroundColor: 'rgba(59, 130, 246, 0.7)',
          borderColor: 'rgb(59, 130, 246)',
          borderWidth: 1
        }
      ]
    };
  });

  readonly chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: { y: { beginAtZero: true } }
  };
}
